module.exports = __webpack_public_path__ + "static/media/blog.c6a4ffdb.png";